import React, { FC, useEffect, useState } from "react";
import { itemProp, tpisummaryNavbar } from "../../utils/tpisummaryNavbar";
import { ProSidebar, Menu, MenuItem, SubMenu, SidebarHeader, SidebarContent } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { Link } from "react-router-dom";
import { ROLES } from "../../utils/constant";
import { useAppSelector } from "../../hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faBars } from "@fortawesome/pro-regular-svg-icons";
import { useLocation } from "react-router-dom";
import logoimg from "../../assets/img/Racklogo.svg";
import smallLogoImg from "../../assets/img/small_logo.svg";
import { emitter } from "../../emitter";
import { faWarehouseFull } from "@fortawesome/pro-solid-svg-icons";
import DecryptProjectData from "../../reusable/decryptData/DecryptProjectData";

const TpiSidebar = () => {
    const userResponse = useAppSelector((state) => state.user);
    const [collapsed, setCollapsed] = useState(false);
    const { user } = userResponse;
    const [toggled, setToggled] = useState(false);
    const [activeItem, setActiveItem] = useState(() => {
        return localStorage.getItem('activeItem') || 'Dashboard';
    });

    const projectdata = DecryptProjectData();

    const location = useLocation();
    const pathname =location.pathname;

    useEffect(() => {
        localStorage.setItem('activeItem', activeItem);
    }, [activeItem]);

    const handleToggleSidebar = (value: any) => {
        setToggled(value);
    };

    const onClickMenuIcon = () => {
        setCollapsed(!collapsed);
        localStorage.setItem("Collaped", `${!collapsed}`)
    };

    const Item: FC<{ item: itemProp }> = ({ item }) => {
        const pathname = useLocation().pathname;

        useEffect(() => {
            if (pathname.includes("/verified-issue-summary") || pathname.includes("/verified-issue-details")) {
                document.getElementById("dropdown5")?.classList.add("open");
            } 
        }, [pathname]);

        return (
            <>
                {
                    item.child.length === 0 && item.access_role.includes(parseInt(ROLES[user.role])) && (
                        <MenuItem
                            icon={item.icon}
                            id={item.classname}
                            active={location.pathname.includes(`${item.urlCommonWord}`)}
                        >
                            {item.title}
                            <Link to={item.path}
                            />
                        </MenuItem>
                    )
                }
                {
                    item.child.length > 0 && item.access_role.includes(parseInt(ROLES[user.role])) && (
                        <SubMenu
                            title={item.title}
                            className="Inner_dropdown"
                            icon={item.icon}
                            id={`dropdown${item.id}`} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}
                        >
                            {
                                item.child &&
                                item.child.map((item: itemProp, index: number) => {
                                    return item.access_role.includes(parseInt(ROLES[user.role])) && (
                                        <MenuItem
                                            active={location.pathname.includes(`${item.urlCommonWord}`)}
                                            key={`submenu_${index}`}
                                        >
                                            {item.title}
                                            <Link to={item.path}
                                            /></MenuItem>
                                    )
                                })
                            }
                        </SubMenu>
                    )
                }
            </>
        )
    }

    const CollapsedSidebar: any = localStorage.getItem("Collaped");

    return (
        <div className="sidenav-bar">
            <div className="logo_div" style={{ width: CollapsedSidebar === "true" ? "60px" : "240px" }}>
                {
                    CollapsedSidebar === "true" ? <img src={smallLogoImg} alt="Logo" className="small_logo" /> : <img src={logoimg} alt="Logo" className="full_logo" />
                }
            </div>
            <div className="navbar_heading_div" style={{ left: CollapsedSidebar === "true" ? "100px" : "270px" }}>
                <h2 className="nav_heading">RAMS by iNODE</h2>
            </div>
            <ProSidebar
                collapsed={CollapsedSidebar === "true"}
                toggled={toggled}
                onToggle={handleToggleSidebar}
                breakPoint="sm"
            >
                <SidebarHeader>
                    <SidebarHeader style={{ left: CollapsedSidebar === "true" ? "70px" : "251px" }}>
                        <div onClick={onClickMenuIcon}>
                            <FontAwesomeIcon icon={faBars} />
                        </div>
                    </SidebarHeader>
                </SidebarHeader>
                <SidebarContent>
                    <Menu>
                        <MenuItem
                            icon={<FontAwesomeIcon icon={faWarehouseFull} />}
                            id={"default"}
                            className="warehousename"
                            style={{ marginBottom: "15px" }}
                        >
                            <div className="">
                                <h6>{projectdata?.company_name}</h6>
                                <span>{projectdata?.country}</span>
                            </div>
                        </MenuItem>
                        <MenuItem
                            icon={<FontAwesomeIcon icon={faArrowLeft} />}
                            id={"default"}
                            onClick={() => { emitter.emit('tpisidebar', 'false'); localStorage.removeItem("tpidetails"); localStorage.removeItem("tpisidebar"); }}
                            style={{ borderBottom: "1px solid #ddd", marginBottom: "15px" }}
                        >
                            Back to TPI Inspection Summary
                            <Link to={"/tpi-inspection-summary"} />
                        </MenuItem>
                        {tpisummaryNavbar &&
                            tpisummaryNavbar.map((value: itemProp, index: number) => (
                                <Item item={value} key={index} />
                            ))}
                    </Menu>
                </SidebarContent>
            </ProSidebar>
        </div>
    );
};

export default TpiSidebar;
